module.exports = "/assets/85e090c0e9267611232991d280b5e4be.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/VN.png
// module id = 1932
// module chunks = 0